/**
 * @file mainNavToggle
 *
 * @module nav
 *
 */

import $ from 'jquery';
import mq from './helpers/mq';
import accessibleSubnavDropdownModule from './jquery-accessible-subnav-dropdown';

(function($) {
  'use strict';

  var config = {
    toggleBtn             : '.fpi-header-top-burger .fpi-cta',
    toggleWrapper         : '.fpi-header-top-burger',
    mainNavWrapper        : '.fpi-mainNav-wrapper',
    subNavWrapper         : '.fpi-mainNav-subnav',
    mainNavLink           : '.fpi-mainNav-link',
    mainNav               : '.fpi-mainNav',
    mainNavList           : '.fpi-mainNav-list',
    mainNavItem           : '.fpi-mainNav-list > li',
    mobileMainNavWrapper  : '.fpi-header-bottom .fpi-mainNav-wrapper',
    desktopMainNavWrapper : '.fpi-header-top .fpi-mainNav-wrapper',
    overlay               : '.fpi-overlay',
    class                 : 'is-opened',
  };

  /**
   * Extend the nav object with functions responsible for the display behaviors
   * @memberof module:nav
   */

  function mainNavToggle() {
    $(config.toggleBtn).on('click.mainNavToggle', function() {
      $(config.toggleWrapper).toggleClass(config.class);
      $(config.mainNavWrapper).toggleClass(config.class);

      if (!$(config.toggleWrapper).hasClass(config.class)) {
        $(config.mainNavLink).removeClass(config.class);
        $(config.subNavWrapper).removeClass(config.class);
      }
    });
  }

  function subNavToggle() {
    $(config.mainNavLink).on('click.subNavToggle', function(e) {
      if (mq.isSmallerThan('M')) {
        if ($(this).next($(config.subNavWrapper)).length) {
          e.preventDefault();
          $(this).toggleClass(config.class);
          $(this).next($(config.subNavWrapper)).toggleClass(config.class);
        }
      }
    });

    $(config.mainNavLink).on('mouseenter.subNavToggle', function() {
      if (mq.isBiggerThan('M')) {
        if ($(this).next($(config.subNavWrapper)).length)  {
          if (typeof $(config.subNavWrapper).attr('data-visually-hidden') !== undefined && $(config.subNavWrapper).attr('data-visually-hidden') !== false) {
            $(config.overlay).addClass(config.class);
          }
        }
      }
    });

    $(config.mainNavItem).on('mouseleave.subNavToggle', function() {
      if (mq.isBiggerThan('M')) {
        if ($(this).next($(config.subNavWrapper)).length)  {
          if (typeof $(config.subNavWrapper).attr('data-visually-hidden') !== undefined && $(config.subNavWrapper).attr('data-visually-hidden') !== true) {
            $(config.overlay).removeClass(config.class);
          }
        }
      }
    });
  }

  function mainNavClose() {
    $(window).on('resize.mainNavClose', function () {
      if (mq.isBiggerThan('M')) {
        if ($(config.mainNavWrapper).hasClass(config.class)) {
          $(config.mainNavWrapper).removeClass(config.class);
          $(config.toggleWrapper).removeClass(config.class);
        }

        if ($(config.mainNavLink).hasClass(config.class)) {
          $(config.mainNavLink).removeClass(config.class);
          $(config.subNavWrapper).removeClass(config.class);
        }
      }
    });
  }

  function desktopSubNavToggle() {
    if(mq.isBiggerThan('M')) {
      accessibleSubnavDropdownModule();
      $(config.mainNavList).addClass('js-nav-system');
      $(config.mainNavItem).addClass('js-nav-system__item');
    }

    if (mq.isSmallerThan('M')) {
      $(config.mainNavList).removeClass('js-nav-system');
      $(config.mainNavItem).removeClass('js-nav-system__item');
    }
  }

  function subNavCheck() {
    if ($(config.mainNavItem).find($(config.subNavWrapper)).length) {
      $(config.mainNavItem).find($(config.subNavWrapper)).closest($(config.mainNavItem)).addClass('has-subnav');
    }
  }

  $(window).on('resize', function () {
    desktopSubNavToggle();
  });

  // init
  $(document).ready(function() {
    mainNavToggle();
    mainNavClose();
    subNavToggle();
    desktopSubNavToggle();
    subNavCheck();
  });

})($);



// WEBPACK FOOTER //
// ./src/js/mainNavToggle.js